/**
 * Utility function to get the full URL for avatar images
 * Prepends the API base URL to relative avatar image paths
 */
export const getAvatarImageUrl = (avatarImage?: string): string | undefined => {
  if (!avatarImage) return undefined;

  // If it's already a full URL (starts with http), return as is
  if (avatarImage.startsWith('http://') || avatarImage.startsWith('https://')) {
    return avatarImage;
  }

  // Get API base URL from environment or default
  const apiBaseUrl = process.env.REACT_APP_API_BASEURL || 'http://localhost:3000';

  // Remove leading slash from avatarImage if present
  const cleanPath = avatarImage.startsWith('/') ? avatarImage.substring(1) : avatarImage;

  return `${apiBaseUrl}/${cleanPath}`;
};
